import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=367d9d0e"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=367d9d0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports